import { API_WALLET_URL, URL_TERM } from 'config'
import { apiCall } from './base'

export const ADVANCE_TERMS_SLUG = 'CASH-ADVANCE'

export const getTerms = (app) =>
  apiCall(`${URL_TERM}/api/v1/${app}?show_body=1`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  }).then((res) => res.data.result)

export const getTermsPdf = () =>
  apiCall(`${URL_TERM}/api/v1/wallet/pdf`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true,
    responseType: 'blob'
  })
